import React, {useCallback, useContext, useMemo} from 'react';
import {Button, Typography} from "@mui/material";
import {getAccountInfo} from "../../../../utils/GenericUtils";
import {actions} from "../../../../utils/dictionaries/Actions";
import {useHistory} from "react-router-dom";
import {AppContext} from "../../../../App";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {HomeStyle} from "../../../../styles/pages/home/HomeStyle";
import ActionTile from "./ActionTile";
import {actionTileColors} from "./actionTileColors";

const ActionCard = () => {
	const classes = HomeStyle();
	const history = useHistory();
	const appContext = useContext(AppContext);
	const account = getAccountInfo() || {};

	const visibleActions = useMemo(() => Object.entries(actions)
		.filter(([key]) => account.roles?.some((accountRole) => actions[key].roles
			.some((actionRole) => actionRole === accountRole)))
		.slice(0, 6), [account.roles]);

	const actionSelected = useCallback((action) => {
		if (account.roles?.some(myRole => action.roles.some(actionRole => actionRole === myRole))) {
			history.push(action.path);
		} else {
			setOpenSnackbar("warning", "Non hai i permessi per aprire questa sezione.", appContext.dispatch);
		}
	}, [account.roles, history, appContext.dispatch]);

	const goToActions = useCallback(() => {
		history.push("/gestione/azioni");
	}, [history]);

	return (
		<section className={classes.card}>
			<header className={classes.cardHeader}>
				<div>
					<Typography className={classes.cardTitle}>Azioni frequenti</Typography>
					<Typography className={classes.cardSubtitle}>
						Le sezioni piu utili per il tuo profilo, pronte da aprire.
					</Typography>
				</div>
				<Button variant="outlined" size="small" onClick={goToActions}>
					Vedi tutte
				</Button>
			</header>

			<div className={classes.actionGrid}>
				{visibleActions.map(([key, action], index) => {
					return (
						<ActionTile
							key={key}
							action={action}
							classes={classes}
							colors={actionTileColors[index % actionTileColors.length]}
							onSelect={() => actionSelected(action)}
						/>
					);
				})}
			</div>
		</section>
	);
};

export default React.memo(ActionCard);
